<template>
  <router-view />
</template>

<script>
export default {
  name: 'Permission'
}
</script>

<style scoped>

</style>
